export default {
  title: {
    base: 'Become part',
    keyword: 'of our journey',
  },
  cards: JOURNEY_CARDS,
};
